import style from "./style.module.sass";
import React from "react";


export const PaperBlock: React.FC<{ style?: any }> = (props) => {
    return <div className={style.paperBlock} style={props.style}>
        {props.children}
    </div>
};
